import React from 'react'
import { Signup } from '../../../components'

export const SignupPage = () => {
  return (
    <Signup />
  )
}
